import { render } from "./ItemSort.vue?vue&type=template&id=64ae7b70&scoped=true"
import script from "./ItemSort.vue?vue&type=script&lang=js"
export * from "./ItemSort.vue?vue&type=script&lang=js"

import "./ItemSort.vue?vue&type=style&index=0&id=64ae7b70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ae7b70"]])

export default __exports__